var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"region-savings-badge primary-bg-c1 p-2",class:_vm.badgeClass},[_c('p',{staticClass:"font-weight-bold font-size-22 mb-0"},[_vm._v(_vm._s(_vm.absoluteSaving)+"%")]),_c('p',{staticClass:"text-muted mb-0"},[_vm._v(_vm._s(_vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }